<!-- 利用規約コンポーネント -->
<template>
    <dd class="agreement">
        <template v-if="invalid">
            <span class="errNote pb-10">ＪリーグID利用規約への同意が必要です。</span>
        </template>
        <label class="chk" :tabindex="0" @keydown.enter="executeChangeOnEnter">
            <input v-model="agreement"
                   @change="change"
                   type="checkbox"
                   value="agree"
                   tabindex="-1"
                   class="require-agreement">
            <i></i>ＪリーグID利用規約に同意します。
        </label>
        <span class="formNote">
        <a target="_blank" href="https://auth2.jleague.jp/contents/agreement.html">ＪリーグID利用規約を確認する</a>
    </span>
    </dd>
</template>

<script>
export default {
    name: 'UserInfoAgreementField',
    data: function(){
        return {
            agreement: false,
            invalid: false
        }
    },
    props: {
        checked: {
            type: Boolean,
            required: true
        }
    },
    created: function(){
        this.agreement = this.checked;
    },
    methods: {
        change: function(){
            this.invalid = !this.agreement;
            this.$emit('check-agreement', this.agreement);
        },
        executeChangeOnEnter: function(event) {
            const target = event.target.querySelector('input');
            if (target) {
                this.agreement = !this.agreement;
                target.checked = !target.checked;
                this.change();
            }
        }
    }
}
</script>
